/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import 'cross-fetch/polyfill';
import { MERCHANT_REMINDERS_CONFIG_REQUEST, MERCHANT_REMINDERS_CONFIG_REQUEST_FAIL, MERCHANT_REMINDERS_CONFIG_RESPONSE_RECEIVE } from '@engine/actions/action-types';
/**
 * Action Creators for Merchant Reminders Config
 */

export var merchantRemindersConfigRequest = function merchantRemindersConfigRequest() {
  return {
    type: MERCHANT_REMINDERS_CONFIG_REQUEST
  };
};
export var merchantRemindersConfigRequestFail = function merchantRemindersConfigRequestFail() {
  return {
    type: MERCHANT_REMINDERS_CONFIG_REQUEST_FAIL
  };
};
export var merchantRemindersConfigResponseReceive = function merchantRemindersConfigResponseReceive(data) {
  return {
    type: MERCHANT_REMINDERS_CONFIG_RESPONSE_RECEIVE,
    data: data
  };
};
export function saveMerchantRemindersConfig(url, data) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'PUT';
  return function (dispatch) {
    dispatch(merchantRemindersConfigRequest());
    return fetch(url, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': window.CSRF
      },
      body: JSON.stringify({
        reminders_config: {
          reminders_settings: data
        }
      })
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(merchantRemindersConfigResponseReceive(json));
    })["catch"](function () {
      return dispatch(merchantRemindersConfigRequestFail());
    });
  };
}